module.exports = function (callback) {

	if (document.readyState === 'complete' || document.readyState === 'interactive') {
		// Already ready or interactive, execute callback
		callback.call();
	}
	else if (document.attachEvent) {
		// Old browsers
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState === 'interactive')
				callback.call();
		});
	}
	else if (document.addEventListener) {
		// Modern browsers
		document.addEventListener('DOMContentLoaded', callback);
	}
}



//////////////////
// WEBPACK FOOTER
// /Users/mishatrombley/Documents/Sites/11th-hour-racing-team/app/public/wp-content/themes/11th-hour-racing-team/node_modules/lite-ready/liteready.js
// module id = 14
// module chunks = 0